import axios from "axios";

//  export const fetchRainfallScreenData = (urlParam) =>
//      axios.get("http://dev.flowworks.com/network/hmiscreens/surreyrain/Content/mockApiEndpoints/site-data.json?" + urlParam ).then( (response) => response);

export const fetchRainfallScreenData = (siteId, past1hrRainfallChannel, past24hrRainfallChannel, past48hrRainfallChannel, rawRainfallChannel) =>
    axios.get("/network/hmiscreens/surreyrain/getrainfalldata" +
                "?siteId=" + siteId +
                "&past1hrRainfallChannel=" + past1hrRainfallChannel +
                "&past24hrRainfallChannel=" + past24hrRainfallChannel +
                "&past48hrRainfallChannel=" + past48hrRainfallChannel +
                "&rawRainfallChannel=" + rawRainfallChannel
    ).then( (response) => response);


// WEBPACK FOOTER //
// ./src/api/api.js